class PageScroller {
  private readonly elementId = null

  constructor (elementId) {
    this.elementId = elementId
  }

  public getElementId = () => {
    return this.elementId
  }

  public scrollToElement = () => {
    const element = document.querySelector(`#${this.getElementId()}`)
    if (element) {
      if (document.hidden) {
        window.scrollTo({
          top: element.getBoundingClientRect().top,
          left: 0,
          behavior: 'smooth',
        })
        return
      }
      element.scrollIntoView({ alignToTop: true, behavior: 'smooth' })
    }
  }

  public goToElement = () => {
    const element = document.querySelector(`#${this.getElementId()}`)
    if (element) {
      element.scrollIntoView(true)
    }
  }
}

export default PageScroller
